// Put all DOM reliant calls in this function to ensure they are only called when the DOM is ready
const initNodeTypesOnLoad = function () {
};

// If the script is initialized after the document is already loaded, initialize modules instantly
if (document.readyState !== 'loading') {
    initNodeTypesOnLoad();
} else {
    // else add an event listener for when the document is fully loaded
    document.addEventListener('DOMContentLoaded', initNodeTypesOnLoad);
}
